import { useEffect, useState, useCallback } from "react";

export interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isExpired: boolean;
}

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export function useCountdown(targetDateUnix: number, offset: number = 0): TimeLeft {
  const calculateTimeLeft = useCallback((): TimeLeft => {
    const currentUnixTime = (Date.now() / 1000) + offset;
    const difference = (targetDateUnix - currentUnixTime) * 1000;

    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        isExpired: true,
      };
    }

    return {
      days: Math.floor(difference / DAY),
      hours: Math.floor((difference % DAY) / HOUR),
      minutes: Math.floor((difference % HOUR) / MINUTE),
      seconds: Math.floor((difference % MINUTE) / SECOND),
      isExpired: false,
    };
  }, [targetDateUnix]);

  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [calculateTimeLeft]);

  return timeLeft;
}
